<template>
	<div>
		<div class="row" v-for="(item, index) in itens">
			<div class="input-field col s12 m12 12 x12">
				<label v-if="item[2] == 'proponente'"><b style="font-size: 18px;">{{item[0]}}</b><div style="color:red">(*campo de preenchimento exclusivo de proponentes pela ação)</div></label>
				<label v-if="item[2] == 'aluno' && bolsista"><b style="font-size: 18px;">{{item[0]}}</b><div style="color:red">(*campo de preenchimento exclusivo de alunos bolsistas)</div></label>
				<label v-if="item[2] == 'aluno' && !bolsista"><b style="font-size: 18px;">{{item[0]}}</b><div style="color:red">(*campo de preenchimento exclusivo de alunos voluntários)</div></label>
				<label v-if="item[2] == 'ambos' && bolsista"><b style="font-size: 18px;">{{item[0]}}</b><div style="color:red">(*campo de preenchimento para ambos bolsista e proponente)</div></label>
				<label v-if="item[2] == 'ambos' && !bolsista"><b style="font-size: 18px;">{{item[0]}}</b><div style="color:red">(*campo de preenchimento para ambos voluntário e proponente)</div></label>
			</div><br><br><br>
			<div class="input-field col s12 m12 12 x12">
				<textarea class="materialize-textarea" v-model='item[3]' :id="index" :name="index" :maxlength="item[1]" :data-length="item[1]" :readonly="edit=='false' || (item[2] != 'ambos' && item[2] != perfil)"></textarea>
			</div> 
		</div>

		<div class="row" v-if="edit == 'true'">	
			<div class="input-field col s6 m6 l3 xl3">
				<button type="submit" class="btn"><i class="material-icons left">save</i>Salvar</button>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
		name: "VueRelatorioBolsaForm",
		props: [
			'campos', 
			'perfil',
			'edit',
			'bolsista'
		],
		data () {
			return {
				itens: JSON.parse(this.campos)
			}
		},
		mounted() {
			var i = $('textarea').length;
			while (i > 0) 
				$("#" + i--).characterCounter();
		}
	}
</script>